<template>
    <div>
        <b-card>
            <span style="font-size: 2rem; font-weight: 500;">{{step_data.step_name}}</span>
            <form-plugin 
            :viewFile="clientMediaFile(step_uid)"
            :step="step_data.render_order"
            @hasLoaded="has_form_loaded = true"
            @downloadFile=processFileDownload
            @uploaderData="processUpload"
            @formDataUpdated="updateFormData"
            :viewData="step_form_data"
            :uid="step_uid"></form-plugin>



            <b-button v-if="has_form_loaded" @click="save" variant="success">
            Save</b-button>
        </b-card>
        <DownloadModal v-if="showDownloadModal == true" />
    </div>
</template>

<script>
import Uploader from 'simple-uploader.js'
//eslint-disable-next-line
import _ from 'lodash'
import Swal from 'sweetalert2';
import DownloadModal from '@/components/client/downloadModal.vue'
import { licenseAppState, licenseAppMethods } from '@/state/helpers'
export default {
    data:() => ({
        showDownloadModal: false,
        has_form_loaded: false,
        current_form_data: {},
        params:{},
        hasSaved: false,
    }),
    components:{
        DownloadModal,
    },
    computed:{
        ...licenseAppState,
        step_form_data(){
            return this.step_data.spreadify_views[0].form_data
        },
        step_uid(){
            return this.step_data.spreadify_views[0].spreadify_uid
        },
    },
    methods:{
        ...licenseAppMethods,
        updateFormData(newData){
            //*event fired from <form-plugin>
            this.current_form_data = newData.data;
        },
        //* Uploader event method
        processUpload(file){
            //*Configure upload params
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/licenseapp/uploadmedia',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:{
                    step_id : this.step_data.id,
                    spreadify_uid : this.step_uid,
                    key : 'document_file',
                },
                testChunks: false,
                fileParameterName: 'file', //Set the upload post param which will contain the binary payload
                singleFile: false, //Limit upload to one file
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile) {
                Swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'File Uploaded', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
            });
            /*
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                 //todo - can remove this block
                console.log('fileAdded', file);
            });*/

            this.$nextTick(()=>{
                //* Handle single or batch upload
                if(file.length == undefined){
                    uploader.addFile(file);
                    this.$nextTick(()=>{
                        uploader.upload();
                    });
                }
                else if(file.length){
                    for(let i = 0; i < file.length; i++ ){
                        uploader.addFile(file[i]);
                    }
                    this.$nextTick(()=>{
                        uploader.upload();
                    });
                }
            });
        },
        processFileDownload(params){
            this.showDownloadModal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.showDownloadModal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },
        clientMediaFile(uid){
            let files = [];
            this.step_data.client_uploads.forEach((file) => {
                if(file.spreadify_uid == uid){
                    files.push(file);
                }
            });
            return files;
        },
        save(){
            this.$emit('back', this.step_data.id);
        }
    },
    mounted(){
        this.params = {
            step_id: this.step_data.id,
            form_data:[],
        }
    },
    beforeDestroy(){
        //*Fetch new data for the status bar and project timeline table
        if(this.hasSaved){
            this.loadAppData();
        }
    }
}
</script>

<style>

</style>